import type { JobStatus } from '@agent/shared'

// ISSUE #10: Job status を視覚的に区別するための小さなコンポーネント。
const STATUS_STYLES: Record<JobStatus, string> = {
  created: 'bg-slate-100 text-slate-700',
  planned: 'bg-indigo-100 text-indigo-700',
  awaiting_approval: 'bg-amber-100 text-amber-700',
  queued: 'bg-sky-100 text-sky-700',
  claimed: 'bg-blue-100 text-blue-700',
  running: 'bg-blue-100 text-blue-700',
  completed: 'bg-emerald-100 text-emerald-700',
  failed: 'bg-rose-100 text-rose-700',
  cancelled: 'bg-slate-200 text-slate-700',
  evaluated: 'bg-violet-100 text-violet-700',
  learned: 'bg-violet-100 text-violet-700',
}

export function StatusBadge({ status }: { status: JobStatus }) {
  const cls = STATUS_STYLES[status] ?? 'bg-slate-100 text-slate-700'
  return (
    <span className={`inline-block rounded px-2 py-0.5 text-xs font-medium ${cls}`}>
      {status}
    </span>
  )
}
